var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "atmo-content-group" },
    [
      _c(
        "AccordionItem",
        {
          staticClass: "atmo-hash-jump-point",
          attrs: {
            visible: _vm.$route.hash === "#second-offer-contract",
            title: "Предложить заключить контракт второму месту",
            "header-class": "fs-22",
            id: "second-offer-contract",
          },
        },
        [
          _c("h5", { staticClass: "grey-color fw-600" }, [
            _vm._v("Информация о поставщике (второе место)"),
          ]),
          _c("text-row-link", {
            attrs: {
              compact: "",
              label: "Наименование",
              "router-link": {
                name: "OrganizationShow",
                params: { id: _vm.purchaseItem.second_offer.organization.id },
              },
            },
            model: {
              value: _vm.purchaseItem.second_offer.organization.full_name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.purchaseItem.second_offer.organization,
                  "full_name",
                  $$v
                )
              },
              expression: "purchaseItem.second_offer.organization.full_name",
            },
          }),
          _c("text-row", {
            attrs: { compact: "", label: "ИНН" },
            model: {
              value: _vm.purchaseItem.second_offer.organization.inn,
              callback: function ($$v) {
                _vm.$set(_vm.purchaseItem.second_offer.organization, "inn", $$v)
              },
              expression: "purchaseItem.second_offer.organization.inn",
            },
          }),
          _c("text-row", {
            attrs: { compact: "", label: "КПП" },
            model: {
              value: _vm.purchaseItem.second_offer.organization.kpp,
              callback: function ($$v) {
                _vm.$set(_vm.purchaseItem.second_offer.organization, "kpp", $$v)
              },
              expression: "purchaseItem.second_offer.organization.kpp",
            },
          }),
          _c("text-row", {
            attrs: { compact: "", label: "ОГРН" },
            model: {
              value: _vm.purchaseItem.second_offer.organization.ogrn,
              callback: function ($$v) {
                _vm.$set(
                  _vm.purchaseItem.second_offer.organization,
                  "ogrn",
                  $$v
                )
              },
              expression: "purchaseItem.second_offer.organization.ogrn",
            },
          }),
          _c("text-row-single-document", {
            attrs: { compact: "", label: "Карточка предприятия" },
            model: {
              value: _vm.purchaseItem.second_offer.organization_card_attachment,
              callback: function ($$v) {
                _vm.$set(
                  _vm.purchaseItem.second_offer,
                  "organization_card_attachment",
                  $$v
                )
              },
              expression:
                "purchaseItem.second_offer.organization_card_attachment",
            },
          }),
          _c("text-row", {
            attrs: { compact: "", label: "Рейтинг ИС" },
            model: {
              value: _vm.purchaseItem.second_offer.organization.rating,
              callback: function ($$v) {
                _vm.$set(
                  _vm.purchaseItem.second_offer.organization,
                  "rating",
                  $$v
                )
              },
              expression: "purchaseItem.second_offer.organization.rating",
            },
          }),
          _c("text-row-documents", {
            attrs: {
              compact: "",
              label:
                "Дополнительные документы, приложенные поставщиком к предложению",
            },
            model: {
              value: _vm.purchaseItem.second_offer.documents,
              callback: function ($$v) {
                _vm.$set(_vm.purchaseItem.second_offer, "documents", $$v)
              },
              expression: "purchaseItem.second_offer.documents",
            },
          }),
          _c("offer-supplier-requirements-view", {
            attrs: {
              "purchase-item": _vm.purchaseItem,
              offer: _vm.purchaseItem.second_offer,
            },
          }),
          _c("h5", { staticClass: "grey-color fw-600 pt-2" }, [
            _vm._v("Стоимость"),
          ]),
          _c("text-row-price", {
            attrs: {
              label: "Ценовое предложение второго места",
              value: _vm.purchaseItem.second_offer.total_cost,
              compact: "",
            },
          }),
          _c("form-row-specification-table-with-vat-view", {
            attrs: {
              "price-wo-vat": _vm.purchaseItem.second_offer.price_wo_vat,
              "total-cost": _vm.purchaseItem.second_offer.total_cost,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("h5", { staticClass: "grey-color fw-600 pt-2" }, [
                      _vm._v("Спецификация предложения"),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.purchaseItem.second_offer.deliverables,
              callback: function ($$v) {
                _vm.$set(_vm.purchaseItem.second_offer, "deliverables", $$v)
              },
              expression: "purchaseItem.second_offer.deliverables",
            },
          }),
          _vm.form.contract_attachment?.length > 0
            ? _c("form-row-single-line-document-upload", {
                attrs: {
                  "label-cols-lg": 3,
                  v: _vm.$v.form.contract_attachment,
                  title: "Контракт",
                },
                model: {
                  value: _vm.form.contract_attachment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contract_attachment", $$v)
                  },
                  expression: "form.contract_attachment",
                },
              })
            : _vm._e(),
          !_vm.purchaseItem.without_limits
            ? _c("limits-editable-table", {
                attrs: {
                  "total-cost": _vm.purchaseItem.second_offer.total_cost,
                  "limit-year": _vm.purchaseItem.purchase_limit_year,
                  "order-type": _vm.purchaseItem.order_type,
                  "purchase-type": "fl44",
                  "purchase-id": _vm.purchaseItem.id,
                },
                on: { validate: _vm.limitsValidate },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("h5", { staticClass: "grey-color fw-600" }, [
                            _vm._v("Измените лимиты"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3796081880
                ),
                model: {
                  value: _vm.form.limits,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "limits", $$v)
                  },
                  expression: "form.limits",
                },
              })
            : _vm._e(),
          _c("form-row-single-line-document-upload", {
            attrs: {
              "label-cols-lg": 3,
              v: _vm.$v.form.contract_attachment,
              title: "Контракт",
            },
            model: {
              value: _vm.form.contract_attachment,
              callback: function ($$v) {
                _vm.$set(_vm.form, "contract_attachment", $$v)
              },
              expression: "form.contract_attachment",
            },
          }),
          _c(
            "b-overlay",
            {
              staticClass: "d-inline-block",
              attrs: {
                show: _vm.isDataSending,
                opacity: "0.6",
                rounded: "",
                "spinner-small": "",
                "spinner-variant": "primary",
              },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "text-uppercase ml-1",
                  attrs: { disabled: !_vm.isValid, variant: "custom-green" },
                  on: { click: _vm.storeSecondContract },
                },
                [_vm._v("Отправить контракт")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }